import React from "react";
import { Link } from "react-router-dom";
import * as DateHelper from "../utils/date.formatter";
import { REACT_APP_MODE } from "../config";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";
import { useDispatch } from "react-redux";
import { removeCampaignItem } from "../redux/actions/asset.actions";

export default props => {
  const dispatch = useDispatch();
  const handleRemove = key => ev => {
    ev.preventDefault();
    if (window.confirm(i18n.t("campaign.item_remove_confirm_msg"))) {
      dispatch(removeCampaignItem(key));
    }
  };

  if (!props.data || props.data.length === 0) {
    return <div className="empty-data">{i18n.t("system.empty_data")}</div>;
  }

  return (
    <Translation>
      {t => (
        <table className="table-list-simple">
          <thead>
            <tr>
              <th>{t("common.name")}</th>
              <th>{t("common.phone")}</th>
              <th className="last">{t("common.action")}</th>
            </tr>
          </thead>
          <tbody>
            {props.data.map(item => {
              return (
                <tr key={item.key}>
                  <td>
                    <span className="table-edit-text">{item.asset_name}</span>
                  </td>
                  <td>
                    <span className="table-edit-text">{item.asset_number}</span>
                  </td>
                  <td className="last">
                    <a
                      className="table-edit-button"
                      onClick={handleRemove(item.key)}
                    >
                      <i className="fal fa-times"></i>
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </Translation>
  );
};
